const templates = {
  weeks: [
    'Week 1,1/1/26',
    'Week 2,1/8/26',
    'Week 3,1/15/26',
    'Week 4,1/22/26',
    'Week 5,1/29/26',
    'Week 6,2/5/26',
    'Week 7,2/12/26',
    'Week 8,2/19/26',
    'Week 9,2/26/26',
    'Week 10,3/5/26',
    'Week 11,3/12/26',
    'Week 12,3/19/26',
    'Week 13,3/26/26',
    'Week 14,4/2/26',
    'Week 15,4/9/26',
    'Week 16,4/16/26',
    'Week 17,4/23/26',
    'Week 18,4/30/26',
    'Week 19,5/7/26',
    'Week 20,5/14/26',
    'Week 21,5/21/26',
    'Week 22,5/28/26',
    'Week 23,6/4/26',
    'Week 24,6/11/26',
    'Week 25,6/18/26',
    'Week 26,6/25/26',
    'Week 27,7/2/26',
    'Week 28,7/9/26',
    'Week 29,7/16/26',
    'Week 30,7/23/26',
    'Week 31,7/30/26',
    'Week 32,8/6/26',
    'Week 33,8/13/26',
    'Week 34,8/20/26',
    'Week 35,8/27/26',
    'Week 36,9/3/26',
    'Week 37,9/10/26',
    'Week 38,9/17/26',
    'Week 39,9/24/26',
    'Week 40,10/1/26',
    'Week 41,10/8/26',
    'Week 42,10/15/26',
    'Week 43,10/22/26',
    'Week 44,10/29/26',
    'Week 45,11/5/26',
    'Week 46,11/12/26',
    'Week 47,11/19/26',
    'Week 48,11/26/26',
    'Week 49,12/3/26',
    'Week 50,12/10/26',
    'Week 51,12/17/26',
    'Week 52,12/24/26',
    'Week 53,12/31/26'
  ],
  months: [
    'January,1/1/26',
    'February,2/1/26',
    'March,3/1/26',
    'April,4/1/26',
    'May,5/1/26',
    'June,6/1/26',
    'July,7/1/26',
    'August,8/1/26',
    'September,9/1/26',
    'October,10/1/26',
    'November,11/1/26',
    'December,12/1/26'
  ],
  quarters: [
    'Q1,1/1/26',
    'Q2,4/1/26',
    'Q3,7/1/26',
    'Q4,10/1/26'
  ],
  usHolidays: [
    'New Year’s Day,1/1/26',
    'Martin Luther King Jr. Day,1/19/26',
    'President’s Day,2/16/26',
    'Memorial Day,5/25/26',
    'Juneteenth,6/19/26',
    'Independence Day,7/4/26',
    'Labor Day,9/7/26',
    'Columbus Day,10/12/26',
    'Veterans Day,11/11/26',
    'Thanksgiving Day,11/26/26',
    'Christmas Day,12/25/26'
  ],
  seasons: [
    'Spring,3/20/26',
    'Summer,6/21/26',
    'Autumn,9/22/26',
    'Winter,12/21/26'
  ]
}

export function markerTemplateFor (template) {
  return templates[template]
}
